import React, { ReactElement } from 'react';

export interface Props {
  value: boolean;
}

export const BinaryIcon: React.FC<Props> = ({ value }): ReactElement => {
  return value ? <span className="fa fa-check"></span> : <span className="fa fa-minus"></span>;
};
